import { CommonModule } from '@angular/common';
import { OnInit, Component } from '@angular/core';
import { getAuth, verifyPasswordResetCode } from '@angular/fire/auth';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { take } from 'rxjs/operators';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { ErrorStreamChange } from 'src/app/models/$error.model';
import { AuthService } from 'src/app/services/auth.service';
import { LogService } from 'src/app/services/log.service';
import { LoginComponent } from './login.component';
import { MatButtonModule } from '@angular/material/button';
import { RegisterComponent } from './register.component';
import { ResetPasswordComponent } from './reset-password.component';
import { environment } from '../../../environments/environment';
import { RecaptchaLoaderService, ReCaptchaV3Service } from 'ng-recaptcha';

/**
 * Created by greg on 15/07/2018.
 */

@Component({
    selector: 'login-page',
    template: `
<div class="logo"><icon class="joi-icon" icon="JOI_ICON_WHITE"></icon></div>

<div class="authenticate_container">
    <ng-container *ngIf="auth.is_create_user === true; then register"></ng-container>
    <ng-container *ngIf="auth.is_create_user === false; then login"></ng-container>
    <ng-container *ngIf="is_reset_password === true; then reset_password"></ng-container>
    <ng-container *ngIf="email_validation === true; then email_validated"></ng-container>
    <div class="link center">
      Version {{ uiService.version }} {{ env.production ? '' : '(dev build)'}} {{ env.useEmulator ? '(emulator)' : ''}}
      &bull; <a href="https://www.joi.events/eula" target="_blank">EULA</a>
      &bull; <a href="https://www.joi.events/privacy" target="_blank">Privacy</a>
    </div>
</div>

<ng-template #login>
    <div class="link">New to Joi? <a routerLink="/sign-up">Sign up</a></div>
    <login-component [reauthenticate]="is_verified" [email]="verified_email"></login-component>
</ng-template>
<ng-template #register>
    <div class="link">Already have a Joi ID? <a routerLink="/login">Sign in</a></div>
    <register-component></register-component>
</ng-template>
<ng-template #reset_password>
    <div *ngIf="!!params">
        <reset-password-component [params]="params" [email]="reset_email"></reset-password-component>
    </div>
    <div *ngIf="invalid_reset">
        <div class="authenticate">
            <h1>Try resetting your password again</h1>
            <div class="para">Your request to reset your password has expired or the link has already been used.</div>
            <div class="control">
                <button mat-button color="primary" routerLink="/login">Start over</button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #reset_password>
    <div *ngIf="params">
        <reset-password-component [params]="params" [email]="reset_email"></reset-password-component>
    </div>
    <div *ngIf="invalid_reset">
        <div class="authenticate">
            <h1>Try resetting your password again</h1>
            <div class="para">Your request to reset your password has expired or the link has already been used.</div>
            <div class="control">
                <button mat-button color="primary" routerLink="/login">Start over</button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #email_validated>
  <div *ngIf="!errorMessage">
    <div class="authenticate">
        <h1>Your email has been verified</h1>
        <div class="para">Please login again to refresh your authentication token</div>
        <div class="control">
            <button mat-button color="primary" routerLink="/login">Login</button>
        </div>
    </div>
  </div>
  <div *ngIf="errorMessage">
    <div class="authenticate">
        <h1>There was an issue verifying your email</h1>
        <div class="para">{{errorMessage}}</div>
        <div class="control">
            <button mat-button color="primary" routerLink="/login">Login</button>
        </div>
    </div>
  </div>
</ng-template>
`,
    styleUrls: [`./login.page.scss`],
    imports: [CommonModule, IconComponent, RouterLink, MatButtonModule, LoginComponent, RegisterComponent, ResetPasswordComponent],
    styles: [`
:host { flex:1; position: absolute; top: 0; width: 100%; overflow-y: auto; height: 100%; }
    `],
    standalone: true,
    providers: [ReCaptchaV3Service, RecaptchaLoaderService],
})
export class LoginPageComponent extends Wrapper<LoginPageComponent> implements OnInit {

    is_reset_password;
    email_validation;
    verified_email;
    is_verified;
    errorMessage;
    invalid_reset;
    params;
    reset_email;
    env = environment;

    constructor(
      private log: LogService,
      private route: ActivatedRoute,
      private authService: AuthService,
    ) {
      super()
      this.subCallback(this.route.data, data => {
        this.auth.is_create_user = data['is_create_user'];
        this.is_reset_password = data['is_reset_password'];
        this.is_verified = data['is_verified'];
        console.log({is_reset_password: this.is_reset_password})
        if (this.is_reset_password) {
          this.subCallback(route.queryParams, async params => {
            const code = params['oobCode']
            const mode = params['mode']
            console.log({mode})
            switch(mode){
              case "verifyEmail":
                this.subCallback(this.auth.currentUserData$, u => {
                  this.authService.verityCode(code).then(vc => {
                    console.log({vc, u})
                    this.is_reset_password = false;
                    this.email_validation = true;
                    if(u){
                      this.userService.updateUser({emailVerified: true}, false, {file: "login.page.ts", function: "verifyEmail"})
                      this.log.nonHsSignUpForm(u);
                    // }
                    // console.log({u})
                    // if (u && u.emailVerified) {
                      this.auth.signing_in = false
                      this.router.navigate([this.userService.getHomepage(u)])
                    }
                  }).catch(async error=>{
                    this.errorMessage = error.message;
                    this.is_reset_password = false;
                    this.email_validation = true;
                  });
                })
                break;
              default:
                verifyPasswordResetCode(getAuth(), code).then(email => {
                  // console.log('for email:', email);
                  this.reset_email = email;
                  this.params = params;
                }).catch(error => {
                  this.invalid_reset = true
                  this.auth.$errors.next({ file: 'login.page', function: 'constructor', code: error.code, data: error, message: error.message} as ErrorStreamChange)
                })
                break;
            }
          })
        }
      })
      this.subCallback(this.auth.currentUserData$, u => {
        console.log({u})
        if(u && this.is_verified){
          this.verified_email = u.email;
          this.authService.signOut(true)
        } else if (u && (!this.is_reset_password || u.emailVerified)) {
          this.auth.signing_in = false
          this.router.navigate([this.userService.getHomepage(u)])
        }
      })
      this.subCallback(this.store.select('ui','messages'), messages => {
        const has_refresh_call = messages.filter(msg=>msg.code === this.uiService.FRESH_VERSION).length
        if (has_refresh_call) location.reload()
      })
    }

    ngOnInit() {
      if (this.auth.is_create_user) {
        this.uiService.changePageTitle('Sign up')
      } else {
        this.uiService.changePageTitle('Sign in')
      }
    }

}
